import { useEffect } from "react";
import { useTranslator } from "common/Translation/Translator";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import { useState } from "react";
import { Table } from "@sia/style-guide";
import { renderMobileCellValue } from "./functions";

const SingleOGLTable = () => {
  const translate = useTranslator();
  const [items, setItems] = useState([]);
  const [pendingItems, setPendingItems] = useState([]);

  const columns = [
    { name: "mobile", label: "Daten", class: "small-only" },
    {
      name: "sia_id",
      label: "SIA-ID",
      class: "medium-up",
    },
    {
      name: "name",
      label: "Name",
      class: "medium-up from-date",
    },
  ];

  const getData = () => {
    pgAdapter.getPendingOGLMemberSingle(({ data }) => {
      if (data.ogls) {
        let items_aux = [...data.ogls.active, ...data.ogls.pendig].map((ogl) => {
          let item_aux = {
            id: ogl.sia_id,
            sia_id: ogl.sia_id,
            name: ogl.name,
            panding: true,
          };
          item_aux["mobile"] = renderMobileCellValue(item_aux, columns);
          return item_aux;
        });
        setPendingItems(data.ogls.pendig.map((ogl) => ogl.sia_id));
        setItems(items_aux);
      }
    });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const confirmPendingOGL = (id) => {
    pgAdapter.confirmPendingOGLMemberSingle(Number.parseInt(id), ({ data }) => {
      getData();
    });
  };
  const refusePendingOGL = (id) => {
    pgAdapter.refuseOGLMemberSingle(Number.parseInt(id), ({ data }) => {
      getData();
    });
  };
  const getRowAction = (item) => {
    const isPending = pendingItems.find((pending_item) => pending_item === item.id);
    if (!isPending) {
      return {
        custom: () => <div></div>,
      };
    }
    return {
      custom: () => (
        <div className="pending-row-action">
          <p
            onClick={() => {
              confirmPendingOGL(item.id);
            }}
          >
            {translate("account.customer-data.memberships.ogl.confirm")}
          </p>
          <span>|</span>
          <p
            onClick={() => {
              refusePendingOGL(item.id);
            }}
          >
            {translate("account.customer-data.memberships.ogl.refuse")}
          </p>
        </div>
      ),
    };
  };

  if (items?.length === 0) return <></>;
  return (
    <>
      <div>
        <h3>{translate("account.customer-data.memberships.group.corporates-members-in-ogl")}</h3>
      </div>
      <Table
        columns={columns}
        items={items}
        className={"single-ogl-table"}
        sortable={false}
        getRowClassName={(item) => {
          return pendingItems.find((pending_item) => pending_item === item.id) ? "grayed-out" : "";
        }}
        getRowAction={getRowAction}
        actions={[]}
        addExtraColumn={true}
      />
    </>
  );
};

export default SingleOGLTable;
